import Drawer from "react-modern-drawer";
import { Box, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import HierrachyTree from "./HierrachyTree";
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';
import { useEffect } from "react";

const LegalInfo = ({ legalInfo, setLegalInfo, defaultSearch, handleDefaultSearch, dataSource, setFastSearch }) => {


    const handleModelChange = (event) => {

        setFastSearch(null)
        setLegalInfo(event.target.value);
        if (defaultSearch) {
            console.log("hello")
            handleDefaultSearch(false)
        }
        console.log(event.target.value)
    };

    useEffect(() => {
        if (dataSource === 'google')
            setLegalInfo(null)


    }, [dataSource])

    return (


        <>
            <Box className="drawer-title">Legal Info</Box>

            {/* <h3 style={{ marginLeft: '15px', marginBottom: '0px' }}>Models</h3> */}
            <RadioGroup
                sx={{
                    py: 1,
                    pl: 2,
                    display: 'flex',
                    flexDirection: 'row', // To align items horizontally
                    justifyContent: 'flex-start', // To align items at the start
                }}
                value={legalInfo}
                onChange={handleModelChange}
            >
                <FormControlLabel value="true" control={<Radio />} label="Enabled" sx={{ mr: 1 }} disabled={dataSource != 'google' ? false : true} />
                <FormControlLabel value="false" control={<Radio />} label={<Box sx={{ display: 'flex', alignItems: 'center' }} >
                    Disabled &nbsp; <Tooltip title="If enabled the bot will also search from the legislation data from austlii.edu.au. By default this is disabled, keep it disabled if you want to query only the ATO data"><InfoIcon sx={{ mr: 1 }} /></Tooltip></Box>} sx={{ mr: 1 }} disabled={dataSource != 'google' ? false : true}/>
            </RadioGroup>
        </>

    );
};

export default LegalInfo;
